export default "__VITE_ASSET__8635a0c2__"